/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseOfGetUserPodsResponse } from '../models/ApiResponseOfGetUserPodsResponse';
import type { ApiResponseOfUserPodsUpdateResponse } from '../models/ApiResponseOfUserPodsUpdateResponse';
import type { UserPodsUpdateBody } from '../models/UserPodsUpdateBody';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class UserPodsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns ApiResponseOfGetUserPodsResponse 
     * @throws ApiError
     */
    public getUserPods(): CancelablePromise<ApiResponseOfGetUserPodsResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v2/user-pod/',
        });
    }

    /**
     * @param requestBody 
     * @returns ApiResponseOfUserPodsUpdateResponse 
     * @throws ApiError
     */
    public updateUserPods(
requestBody: UserPodsUpdateBody,
): CancelablePromise<ApiResponseOfUserPodsUpdateResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v2/user-pod/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
